import { Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import 'rxjs/add/observable/throw';

import { LoaderService } from '@app/core.module';
import { TokenService } from './token.service';

export class AppInterceptor implements HttpInterceptor {
    constructor(@Inject(Router) private router: any,
        @Inject(LoaderService) private loaderService: any, @Inject(TokenService) private tokenService: TokenService) { }


    // intercept(httpReq: HttpRequest<any>, next: HttpHandler):
    //     Observable<HttpEvent<any>> {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.handleAccess(request, next));
    }

    private async handleAccess(httpReq: HttpRequest<any>, next: HttpHandler):
        Promise<HttpEvent<any>> {
        let headers: any;
        if (httpReq.headers.has('document')) {
            headers = httpReq.headers;
        } else {
            headers = httpReq.headers.set('Content-Type', 'application/json');
        }
        if (headers && !headers.has('noLoader')) {
            this.loaderService.showLoader(true);
        }
        if (!httpReq.headers.has('noToken')) {
            if (sessionStorage.getItem('bearer-token')) {
                if (await this.tokenService.checkToken()) {
                    headers = headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('bearer-token'));
                }
            }
        } else {
            headers = httpReq.headers.delete('noToken');
        }
        const newReq = httpReq.clone({ headers: headers });
        return next.handle(newReq).toPromise()
            .catch(response => {
                this.loaderService.showLoader(false);
                return throwError(response).toPromise();
            })
            .then((resp) => {
                this.loaderService.showLoader(false);
                return resp;
            });
    }
}
